import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '~/utils/redux/hooks';
import { selectPermission, selectUser } from '~/thunks/auth/authSlice';
import { canViewModule } from '~/utils/helper/permission';
import { privateSetupRoutes } from '~/utils/routes/setup';

// /setup: lands on the first tab the account may view.
const SetupHome = () => {
  const { t } = useTranslation();
  const user = useAppSelector(selectUser);
  const permission = useAppSelector(selectPermission);

  const first = privateSetupRoutes.find((route) => route.inNav !== false && canViewModule(user, permission, route.module));
  if (first) return <Navigate to={first.path} replace />;

  return <p className='text-sm text-muted-foreground'>{t('pages.setup.noAccess')}</p>;
};

export default SetupHome;
